/* @flow */

const defaultSettings = typeof window.localeData !== 'undefined' ? window.localeData : null;

export function getInstanceDefaultCurrencyCode(
    settings: ?{currencyIsoCodeInstanceDefault: string} = defaultSettings
) {
    // Not all environments use localeData, and returning an empty string isn't ideal,
    // so let's throw a console error to let the developer know something's wrong
    if (!settings) {
        console.error('Cannot determine instance default currency iso code'); // eslint-disable-line no-console

        return '';
    }

    return settings.currencyIsoCodeInstanceDefault;
}
